// paymentService.js
import axios from "axios";
import {useSelector} from "react-redux";
const apiUrl = process.env.REACT_APP_API_URL || '';

export const createPaymentIntent = async (data) => {
    try {
        const response = await axios.post(`${apiUrl}/api/stripe/createpaymentintent`, data);
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error("Error creating payment intent");
    }
};


export const createPaymentMethod = async (data) => {
    try {
        const response = await axios.post(`${apiUrl}/api/stripe/createpaymentmethod`, data);

        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error("Error creating payment intent");
    }
};


// working deprecation
export const createStripeCustomer = async (data) => {

    try {
        const response = await axios.post(`${apiUrl}/api/stripe/createstripecustomer`, data);
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error("Error creating payment intent");
    }
};


// export const fetchClientSecret = async (data) =>{
//
// }


const stripeService = {
    createPaymentIntent,
    createPaymentMethod,
    createStripeCustomer
}

export default stripeService;
